import { useAuthContext } from '@offer/auth-lib'
import { useParameters } from '@/hooks/useParameters'

export function useFavoriteAccess() {
  const { user } = useAuthContext()
  const { data } = useParameters(user?.id)

  return (
    data?.some(parameter =>
      parameter.parameter_name === 'ACCESS_FAVORITES' && parameter.parameter_value === 'true',
    ) ?? false
  )
}
